import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';

const { FiMenu, FiX, FiLogOut, FiUser } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    if (isAuthenticated) {
      navigate('/admin');
    } else {
      navigate('/login');
    }
  };

  const navLinkClass = "text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors";

  return (
    <header className="shadow-sm sticky top-0 z-50" style={{ backgroundColor: 'var(--brand-nav-bg, #ffffff)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 flex items-center gap-3">
              <img 
                src={settings.app_logo_url} 
                alt={`${settings.app_name} Logo`}
                className="w-10 h-10 object-contain" 
              />
              <span className="font-bold text-xl text-gray-900 hidden sm:block">{settings.app_name}</span>
            </Link>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" target="_blank" rel="noopener noreferrer" className={navLinkClass}>Home</Link>
            <a 
              href="https://haringey.gov.uk/jobs-training/haringey-learns" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={navLinkClass}
            >
              About
            </a>
            <a 
              href="https://www.webenrol.com/haringeylearns/?page=courses&lang=" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={navLinkClass}
            >
              Our Courses
            </a>
            <Link to="/links" className={navLinkClass}>Links</Link>
            <Link to="/blog" target="_blank" rel="noopener noreferrer" className={navLinkClass}>Blog</Link>
            
            <div className="pl-4 border-l border-gray-200 flex items-center gap-4">
              <button 
                onClick={handleLoginClick} 
                className="flex items-center gap-2 text-sm font-medium text-gray-700 transition-colors"
                onMouseEnter={e => e.currentTarget.style.color = 'var(--brand-primary)'}
                onMouseLeave={e => e.currentTarget.style.color = ''}
              >
                <SafeIcon icon={FiUser} className="w-4 h-4" />
                {isAuthenticated ? (user?.email ? user.email.slice(0, 5).toLowerCase() : 'Admin') : 'Login'}
              </button>
              {isAuthenticated && (
                <button onClick={logout} className="text-gray-400 hover:text-red-500 transition-colors">
                  <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)} 
              className="text-gray-500 hover:text-gray-900 focus:outline-none p-2"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white">
          <div className="pt-2 pb-3 space-y-1 px-4 text-center">
            <Link to="/" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50" style={{}} onMouseEnter={e=>e.currentTarget.style.color='var(--brand-primary)'} onMouseLeave={e=>e.currentTarget.style.color=''}>Home</Link>
            <a href="https://haringey.gov.uk/jobs-training/haringey-learns" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50" onMouseEnter={e=>e.currentTarget.style.color='var(--brand-primary)'} onMouseLeave={e=>e.currentTarget.style.color=''}>About</a>
            <a href="https://www.webenrol.com/haringeylearns/?page=courses&lang=" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50" onMouseEnter={e=>e.currentTarget.style.color='var(--brand-primary)'} onMouseLeave={e=>e.currentTarget.style.color=''}>Our Courses</a>
            <Link to="/links" onClick={() => setIsMenuOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50" onMouseEnter={e=>e.currentTarget.style.color='var(--brand-primary)'} onMouseLeave={e=>e.currentTarget.style.color=''}>Links</Link>
            <Link to="/blog" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50" onMouseEnter={e=>e.currentTarget.style.color='var(--brand-primary)'} onMouseLeave={e=>e.currentTarget.style.color=''}>Blog</Link>
            <div className="pt-4 border-t border-gray-100">
              <button 
                onClick={() => { handleLoginClick(); setIsMenuOpen(false); }} 
                className="w-full text-left px-3 py-2 rounded-md text-base font-medium flex items-center justify-center gap-2"
                style={{ color: 'var(--brand-primary)', backgroundColor: 'var(--brand-primary-light)' }}
              >
                <SafeIcon icon={FiUser} />
                {isAuthenticated ? (user?.email ? `${user.email.slice(0, 5).toLowerCase()} Dashboard` : 'Admin Dashboard') : 'Staff Login'}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;